// extracted by mini-css-extract-plugin
module.exports = {"notif":"FeedUnit_notif__3dZBC","topLine":"FeedUnit_topLine__2xgp2","date":"FeedUnit_date__1B5tR","title":"FeedUnit_title__1G5K1","address":"FeedUnit_address__2BCHX"};